import "./EcommerceSection.css";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLocale } from "@/i18n/useLocale";
import { SOLUTION_PREFIX } from "@/i18n/config";
import SectionCta from "@/components/SectionCta/SectionCta";
import SolutionLink from "@/components/SolutionLink/SolutionLink";
import StatNumber from "@/components/StatNumber/StatNumber";
import {
  mockTabletEcommerce,
  mockMobileProduct,
  mockMobileAI,
} from "@/assets";

function EcommerceSection() {
  const { t, locale } = useLocale();
  // Se revelan bloques, no elementos sueltos: el texto entra desde la izquierda
  // acompañando la lectura, los mockups escalan, y el pie cierra al final.
  const textRef = useScrollReveal<HTMLDivElement>();
  const statsRef = useScrollReveal<HTMLDivElement>({ delay: 80 });
  const mockupsRef = useScrollReveal<HTMLDivElement>({ delay: 120 });
  const footerRef = useScrollReveal<HTMLDivElement>({ delay: 200 });

  return (
    <section className="ecommerce-section" id="ecommerce">

      <div className="ecommerce-section__content">
        <div className="ecommerce-section__main">
          <div className="ecommerce-section__left reveal--from-left" ref={textRef}>
            <span className="ecommerce-section__badge">{t.ecommerce.badge}</span>

            <h2 className="ecommerce-section__title">{t.ecommerce.title}</h2>

            <ul className="ecommerce-section__list">
              {t.ecommerce.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>

            {/* La tarjeta va apenas despues de los bullets, antes del dato de
                partner: es la accion de esta columna y no tiene que competir
                con una frase larga para que la vean. */}
            <SolutionLink
              to={`${SOLUTION_PREFIX[locale]}/ecommerce-b2b-mayorista`}
              label={t.ecommerce.solutionLink}
              kicker={t.solutionCard.kicker}
              variant="ecommerce"
            />

            {/* El unico dato de la seccion que un competidor no puede copiar.
                Cierra el bloque de texto, debajo de la tarjeta. */}
            <p className="ecommerce-section__partner">{t.ecommerce.partner}</p>
          </div>


          <div className="ecommerce-section__right reveal--zoom" ref={mockupsRef}>
            <div className="ecommerce-section__mockups mockups">
              <img
                loading="lazy"
                src={mockTabletEcommerce}
                alt="Vista de tienda en tablet" title="Vista de tienda en tablet"
                className="mockup ecommerce-section__mockup ecommerce-section__mockup--tablet"
              />

              <img
                loading="lazy"
                src={mockMobileProduct}
                alt="Vista de producto en móvil" title="Vista de producto en móvil"
                className="mockup ecommerce-section__mockup ecommerce-section__mockup--mobile-1"
              />

              <img
                loading="lazy"
                src={mockMobileAI}
                alt="Vista de IA en móvil" title="Vista de IA en móvil"
                className="mockup ecommerce-section__mockup ecommerce-section__mockup--mobile-2"
              />
            </div>
          </div>
        </div>

        {/* Los numeros salen de __main y pasan a una banda propia a todo el
            ancho. Ahi dentro compartian 186px -el 15%- con el texto y los
            mockups, y las etiquetas quebraban en cuatro lineas. */}
        <div className="ecommerce-section__stats-band" ref={statsRef}>
          <div className="ecommerce-section__stat">
            <strong>
              <StatNumber value={50} prefix="+" suffix="%" />
            </strong>
            <span>{t.ecommerce.stats[0]}</span>
          </div>

          <div className="ecommerce-section__stat">
            <strong>
              <StatNumber value={500} prefix="+" delay={180} />
            </strong>
            <span>{t.ecommerce.stats[1]}</span>
          </div>

          <div className="ecommerce-section__stat">
            <strong>
              <StatNumber value={30} prefix="+" suffix="%" delay={360} />
            </strong>
            <span>{t.ecommerce.stats[2]}</span>
          </div>
        </div>

        <div className="ecommerce-section__footer" ref={footerRef}>
          <SectionCta
            label={t.sectionCta.ecommerce}
            variant="ecommerce"
          />
        </div>
      </div>
    </section>
  );
}

export default EcommerceSection;
